export * from './default-icons.const';
export * from './extend-theme-with-default-icons';
